import './App.css';
import Screens from './screens/Screens';

function App() {
  return (
    <div className="App">
      <Screens />

    </div>
  );
}

export default App;
